export interface TableRow {
  x: number;
  y: number;
}

export interface TableViewOptions {
  rows: readonly TableRow[];
  precision: number;
  onXEdit(rowIndex: number, newX: number): void;
}

export interface TableViewHandle {
  root: HTMLElement;
  update(opts: TableViewOptions): void;
  destroy(): void;
}

export function createTableView(root: HTMLElement, opts: TableViewOptions): TableViewHandle {
  function render(state: TableViewOptions): void {
    root.replaceChildren();
    const table = document.createElement('table');
    table.className = 'fn-table';
    const thead = document.createElement('thead');
    const headRow = document.createElement('tr');
    const xHead = document.createElement('th');
    xHead.textContent = 'x';
    const yHead = document.createElement('th');
    yHead.textContent = 'f(x)';
    headRow.appendChild(xHead);
    headRow.appendChild(yHead);
    thead.appendChild(headRow);
    const tbody = document.createElement('tbody');
    state.rows.forEach((row, idx) => {
      const tr = document.createElement('tr');
      const xCell = document.createElement('td');
      xCell.contentEditable = 'true';
      xCell.textContent = row.x.toFixed(state.precision);
      xCell.addEventListener('blur', () => {
        const parsed = Number(xCell.textContent);
        if (Number.isFinite(parsed)) state.onXEdit(idx, parsed);
      });
      const yCell = document.createElement('td');
      yCell.textContent = Number.isFinite(row.y) ? row.y.toFixed(state.precision) : '—';
      tr.appendChild(xCell);
      tr.appendChild(yCell);
      tbody.appendChild(tr);
    });
    table.appendChild(thead);
    table.appendChild(tbody);
    root.appendChild(table);
  }

  let current = opts;
  render(current);
  return {
    root,
    update(next) {
      current = next;
      render(current);
    },
    destroy() {
      root.replaceChildren();
    },
  };
}
